import React from 'react';
import { useParams } from 'react-router-dom';
import samplePhoto from '../../Images/myimg.jpg';
import { blogs } from '../../Data/Blog';
import myLogo from '../../aryannlogo.png';

const BlogPage = () => {
    const { blogId } = useParams();
    const blog = blogs.find((b) => b.id === parseInt(blogId));

    if (!blog) {
        return <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white font-merriweather">Blog not found</div>;
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-900 font-merriweather">
            <main className="pt-8 pb-16 lg:pt-16 lg:pb-24 antialiased bg-gray-900">
                {/* Navigation */}
                <nav className="flex flex-col py-6 sm:flex-row sm:justify-between sm:items-center">
                    <a href="#">
                        <img className="w-auto h-6 sm:h-7" src={myLogo} alt="Logo" />
                    </a>
                    <div className="flex items-center mt-2 -mx-2 sm:mt-0">
                        <a
                            href="/"
                            className="px-3 py-2 mx-2 text-sm font-semibold text-white transition-colors duration-300 transform bg-black rounded-md hover:bg-gray-800"
                        >
                            Experience
                        </a>
                        <a
                            href={blog.href}
                            className="px-3 py-1 text-sm font-semibold text-white transition-colors duration-300 transform border-2 rounded-md hover:bg-gray-700"
                        >
                            Blog
                        </a>
                    </div>
                </nav>

                {/* Blog Content */}
                <div className="px-4 mx-auto max-w-screen-xl">
                    <article className="mx-auto w-full max-w-2xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert">
                        {/* Blog Header */}
                        <header className="mb-6 lg:mb-8 not-format">
                            <address className="flex items-center mb-8 not-italic">
                                <div className="inline-flex items-center mr-4 text-sm text-white dark:text-gray-300">
                                    <img
                                        className="mr-4 w-16 h-16 rounded-full"
                                        src={samplePhoto}
                                        alt={blog.author}
                                    />
                                    <div>
                                        <a
                                            href="#"
                                            rel="author"
                                            className="text-xl font-bold text-white dark:text-gray-300"
                                        >
                                            {blog.author}
                                        </a>
                                        <p className="text-base text-gray-300">{blog.contributor}</p>
                                        <p className="text-base text-gray-300">
                                            <time pubdate dateTime={blog.date} title={new Date(blog.date).toDateString()}>
                                                {new Date(blog.date).toDateString()}
                                            </time>
                                        </p>
                                    </div>
                                </div>
                            </address>
                            <h1 className="mb-8 text-4xl font-extrabold leading-tight text-white lg:mb-10 dark:text-gray-300">
                                {blog.title}
                            </h1>
                        </header>

                        {/* Blog Image */}
                        <figure>
                            <img className="rounded-md" src={blog.imageUrl} alt={blog.title} />
                        </figure>

                        {/* Blog Content */}
                        <div
                            className="mt-6 text-lg leading-relaxed text-white dark:text-gray-300"
                            dangerouslySetInnerHTML={{ __html: blog.content }}
                        />
                    </article>
                </div>
            </main>
        </div>
    );
};

export default BlogPage;